<script setup lang="ts">
import { useNavbarStore } from "@/App/components/AppNavbar/navigation.store";

const navbarStore = useNavbarStore();
</script>

<template>
  <li
    v-for="link in navbarStore.visibleLinks"
    :id="link.routeName"
    :key="link.routeName"
    class="app-navbar-links__item nav-item"
    :data-testid="link.testId"
  >
    <a v-if="link.externalLink" class="nav-link" target="blank" :href="link.externalLink">{{ link.visibleName }}</a>
    <RouterLink v-if="link.routeName" :to="{ name: link.routeName }" class="nav-link">{{
      link.visibleName
    }}</RouterLink>
  </li>
</template>

<style lang="scss" scoped>
.app-navbar-links {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;

  .nav-link {
    color: var(--bs-gray-500);
    transition: all 0.3s ease;

    &:focus,
    &:hover {
      color: var(--bs-gray-100);
    }
  }
}

@media (max-width: 756px) {
  .nav-link {
    display: block;
    width: 100%;
    padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
    clear: both;
    font-weight: 400;
    color: var(--bs-dropdown-link-color);
    text-align: inherit;
    text-decoration: none;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
    margin-bottom: 1rem;
  }
}
</style>
